/* @generated */

// src/assets/ui-icon/line/unknown.tsx
import * as React from "react";
var UnknownLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12c0-1.032-1.389-1.942-3.503-2.481C16.425 6.815 14.952 5.5 12 5.5S7.575 6.815 7.503 9.519C5.388 10.059 4 10.969 4 12c0 .839.918 1.597 2.398 2.142L5.321 16.43l1.358.638 1.177-2.502c1.007.229 2.16.377 3.394.42V18h1.5v-3.013a18.386 18.386 0 0 0 3.352-.41l1.213 2.728 1.37-.61-1.127-2.537C19.064 13.612 20 12.848 20 12ZM9.642 7.64C9.302 7.96 9 8.553 9 9.73v.333a7.767 7.767 0 0 0 6 0v-.332c0-1.18-.301-1.77-.642-2.09C14 7.303 13.315 7 12 7c-1.315 0-2 .303-2.358.64Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  UnknownLine
};
